function Q1OperatingResults2025() {
	return (
		<div className="not-prose">
			<div className="overflow-x-auto">
				<table className="min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<thead>
						<tr>
							<th colSpan={5}>
								<span className="block mb-2 text-right text-[0.75rem] text-black">($ in billions)</span>
							</th>
						</tr>
						<tr className="text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td></td>
							<th colSpan={3} className="align-bottom border-none">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">Commercial Lines Business</th>
						</tr>
						<tr className="text-right no-hover text-[#4B7B9D]">
							<td></td>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Vehicles</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Property</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Total</th>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Written</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="no-hover">Three months ended March 31,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>
								<span className="float-left">$</span>17.6
							</td>
							<td>
								<span className="float-left">$</span>0.7
							</td>
							<td>
								<span className="float-left">$</span>18.3
							</td>
							<td>
								<span className="float-left">$</span>3.9
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>14.5</td>
							<td>0.7</td>
							<td>15.2</td>
							<td>3.7</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>21%</td>
							<td>0%</td>
							<td>20%</td>
							<td>5%</td>
						</tr>

						<tr>
							<td colSpan={5} className="py-4"></td>
						</tr>

						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Earned</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="no-hover">Three months ended March 31,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>
								<span className="float-left">$</span>15.9
							</td>
							<td>
								<span className="float-left">$</span>0.8
							</td>
							<td>
								<span className="float-left">$</span>16.7
							</td>
							<td>
								<span className="float-left">$</span>2.7
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>12.9</td>
							<td>0.7</td>
							<td>13.6</td>
							<td>2.6</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>24%</td>
							<td>9%</td>
							<td>23%</td>
							<td>6%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						<tr>
							<th className="font-bold font-trade text-[#767727] no-hover">Policies in Force</th>
							<th></th>
							<th></th>
							<th></th>
							<th className="text-[0.75rem] font-trade !pr-0 !border-r-0">
								<span className="block mb-2 text-[0.75rem] text-right text-black">(# in thousands)</span>
							</th>
						</tr>
						<tr>
							<td className="no-hover">March 31,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>31,554</td>
							<td>3,576</td>
							<td>35,130</td>
							<td>1,162</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>26,524</td>
							<td>3,209</td>
							<td>29,733</td>
							<td>1,101</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>19%</td>
							<td>11%</td>
							<td>18%</td>
							<td>6%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						<tr className="no-hover text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<th className="align-bottom border-none">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">Commercial Lines Business</th>
						</tr>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Underwriting Ratios</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
						</tr>
						<tr>
							<td className="no-hover">Three months ended March 31,</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
						<tr>
							<td className="cell-indent" colSpan={2}>
								Loss and loss adjustment expense ratio – 2025
							</td>

							<td className="!border-r-0"></td>
							<td>65.4</td>
							<td>67.8</td>
						</tr>
						<tr>
							<td className="cell-indent" colSpan={2}>
								Underwriting expense ratio – 2025
							</td>
							<td className="!border-r-0"></td>

							<td className="border-b-[1px] border-[#BFBFBF]">20.3</td>
							<td className="border-b-[1px] border-[#BFBFBF]">19.7</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2025</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td>85.7</td>
							<td>87.5</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2024</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td>85.0</td>
							<td>91.8</td>
						</tr>
						<tr>
							<td className="cell-indent--3" colSpan={2}>
								Change over prior period
							</td>
							<td className="!border-r-0"></td>
							<td>0.7 pts.</td>
							<td>(4.3) pts.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default Q1OperatingResults2025;
